import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import setInboxRuleRequestStatus from './helpers/setGetInboxRuleRequestStatus';
import getInboxRulesService from '../services/getInboxRulesService';
import store from '../store/store';
import { map } from 'mobx';
import { logUsage } from 'owa-analytics';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Gets inbox rules and stores them in the inboxRules options store
 */
export default select({
    optionState: function () { return store.inboxRulesListState; },
})(action('getInboxRules', datapoints.getInboxRulesDatapoint)(function getInboxRules(state) {
    var optionState = state.optionState;
    setInboxRuleRequestStatus(1 /* Pending */);
    optionState.inboxRuleIds = [];
    optionState.inboxRules = map({});
    var dataPoint = returnTopExecutingActionDatapoint();
    return getInboxRulesService()
        .then(function (response) {
        if (response.WasSuccessful) {
            setInboxRuleRequestStatus(2 /* Complete */);
            var inboxRuleCollection = response.InboxRuleCollection.InboxRules;
            var _a = datapoints.numInboxRules.datapoint, eventName = _a.name, customData = _a.customData;
            logUsage(eventName, customData(inboxRuleCollection.length));
            for (var _i = 0, inboxRuleCollection_1 = inboxRuleCollection; _i < inboxRuleCollection_1.length; _i++) {
                var inboxRule = inboxRuleCollection_1[_i];
                addInboxRuleToStore(inboxRule, optionState);
                if (!optionState.hasLoggedGetInboxRulesInformation) {
                    var _b = datapoints.getInboxRuleDatapoint.datapoint, eventName_1 = _b.name, customData_1 = _b.customData;
                    logUsage(eventName_1, customData_1(inboxRule));
                }
            }
            optionState.hasLoggedGetInboxRulesInformation = true;
        }
        else {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            setInboxRuleRequestStatus(3 /* Error */);
            dataPoint.endWithError(DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        setInboxRuleRequestStatus(3 /* Error */);
        dataPoint.endWithError(DatapointStatus.ServerError, error.message);
    });
}));
var addInboxRuleToStore = action('addInboxRuleToStore')(function addInboxRuleToStore(inboxRule, optionState) {
    var ruleId = inboxRule.Identity.RawIdentity;
    optionState.inboxRuleIds.push(ruleId);
    // transform inbox rule to InboxRuleRowType and add to map
    optionState.inboxRules.set(ruleId, tslib_1.__assign({}, inboxRule, { drop: {
            isDragOver: false,
            draggableItemType: DraggableItemTypes.InboxRule,
        } }));
});
//# sourceMappingURL=getInboxRules.js.map